import { UserRewardType } from 'v2/constants';

export class RewardModel {
  constructor(
    public id: string,
    public type: UserRewardType,
    public value: string,
    public isLevelUp?: boolean
  ) {}
}

export type RewardModelWithoutId = Omit<RewardModel, 'id'>;

export class RewardModelWithCount extends RewardModel {
  constructor(
    public id: string,
    public type: UserRewardType,
    public value: string,
    public count?: number
  ) {
    super(id, type, value);
  }
}

export class RewardModelWithChance extends RewardModel {
  constructor(
    public id: string,
    public type: UserRewardType,
    public value: string,
    public chance: number
  ) {
    super(id, type, value);
  }
}
